import { useMutation } from "@tanstack/react-query";
import { login } from "../api/login";

export const LOGIN_MUTATION_KEY = "login";

export function useLogin() {
  const { mutateAsync } = useMutation({
    mutationKey: [LOGIN_MUTATION_KEY],
    mutationFn: login,
  });

  return {
    login: mutateAsync,
  };
}
